import max from 'lodash/max';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  providers: [],
  providerFilters: {},
};
const slice = createSlice({
  name: 'providers',
  initialState: initialState,
  reducers: {
    setProviders: (state, action) => ({
      ...state,
      providers: action.payload.providers,
    }),
    setProviderFilters: (state, action) => {
      // this isn't being hit
      return {
        ...state,
        providerFilters: action.payload,
      };
    }
  }
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export const {
  setProviders,
  setProviderFilters
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
